import React from "react";
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import * as echarts from "echarts";
import 'echarts-wordcloud';
import _ from 'lodash';


export const ChartWordCloud = (props) => {
    const { jsonData, chartName, chartHeight } = props;
    const { t } = useTranslation();
    const chartRef = React.useRef(null);
    const myChart = React.useRef(null);


    React.useEffect(() => {
        if (!myChart.current && chartRef.current) {
            myChart.current = echarts.init(chartRef.current);
        }

        const changeKeyName = (obj) => {
            if (obj.hasOwnProperty("value")) {
                if(Number(obj["value"]) <= 0) return null;
            }
            if (obj.hasOwnProperty("text")) {
                obj["name"] = t(`assessment.${obj["text"].toLowerCase().trim().replace(' ', '')}`);
                delete obj["text"];
            }
            if (obj.hasOwnProperty("color")) {
                obj["textStyle"] = { color: obj["color"]}
            }
            return obj;
        };

        const option = {
            name: chartName || '',
            series: [{
                type: 'wordCloud',
                shape: 'circle',
                drawOutOfBound: false,
                layoutAnimation: true,
                keepAspect: false,
                shrinkToFit: true,
                textStyle: {
                    fontFamily: 'sans-serif',
                    fontWeight: 'bold',
                },
                emphasis: {
                    focus: 'self',
                    textStyle: {
                        textShadowBlur: 10,
                        textShadowColor: '#333'
                    }
                },
                data: jsonData?.map(changeKeyName) ?? [],
            }],
          };

        if (myChart.current) {
            myChart.current.showLoading();
            myChart.current.setOption(option);
            myChart.current.hideLoading();
        }
        
        
        // 창크기 변경할때 카트를 갱신한다.
        const handleResize = _.debounce(() => {
            if (myChart.current) {
                myChart.current.showLoading();
                myChart.current.setOption(option);
                myChart.current?.resize();
                myChart.current.hideLoading();
            }
        }, 50); // Debounce for 50ms

        window.addEventListener('resize', handleResize);

        return () => {
            try {
                window.removeEventListener('resize', handleResize);
            
                myChart.current && myChart.current.dispose();
                myChart.current && myChart.current.dispose();
                myChart.current = null;
            }
            catch (err) {
                console.log("Unload", new Date().toISOString(), JSON.stringify(err), err);
            }
        };
    }, [jsonData, chartName]);


    return <div ref={chartRef} style={{ width: "100%", height: chartHeight || "200px" }} />;
};

ChartWordCloud.propTypes = {
    jsonData: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.func,
        PropTypes.object,
    ]).isRequired,
    chartName: PropTypes.string,
    chartHeight: PropTypes.string,
};
